// class DetailsDisclosure extends HTMLElement {
//   constructor() {
//     super();
//     this.mainDetailsToggle = this.querySelector('details');
//     this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

//     this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     });
//   }

//   onToggle() {
//     if (!this.animations) this.animations = this.content.getAnimations();

//     if (this.mainDetailsToggle.hasAttribute('open')) {
//       this.animations.forEach((animation) => animation.play());
//     } else {
//       this.animations.forEach((animation) => animation.cancel());
//     }
//   }

//   close() {
//     this.mainDetailsToggle.removeAttribute('open');
//     this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
//   }
// }

// customElements.define('details-disclosure', DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.header = document.querySelector('.header-wrapper');
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);



// var customHeaderMenu = document.querySelector('header-drawer-custom');
// if(customHeaderMenu){
//   var shopMenu = document.querySelector('#HeaderMenu-shop');
//   var MobileMenutrigger = document.querySelector('.mobile-menu-trigger svg#mobile-menu-trigger');
//   var submenu = document.querySelectorAll('li.childmenu-item');
//   var closeMenu = document.querySelector('.close-menu');
//   if(closeMenu){
//     closeMenu.addEventListener('click', function(e){
//       customHeaderMenu.querySelector('.main-header-wrapper').classList.remove('show');
//       customHeaderMenu.querySelector('#menuDrawer').classList.remove('show');
//       document.querySelectorAll('.grandchild-menu').forEach((ele)=> ele.classList.remove('show'));
//       document.querySelectorAll('.list-menu li.active').forEach((ele)=> ele.classList.remove('active'));
//       document.body.classList.remove('custom-drawer-open');
//       document.body.classList.remove('custom-drawer-open-header-menu');
//       document.body.classList.remove('sbmenu-drawer-open');
//     });
//   }
//   if(shopMenu){
//      shopMenu.addEventListener('click', onToggle.bind(this));   
//   }
//   if(MobileMenutrigger) MobileMenutrigger.addEventListener('click', onToggle.bind(this)); 
  
//   if(submenu){
//     submenu.forEach((menu) => {
//       menu.addEventListener('mouseenter', onToggleSubmenu.bind(this));   
//     })
//   }
//   function onToggle(e){
//     e.preventDefault();
//     // document.body.scrollTop = document.documentElement.scrollTop = 0;
//      document.getElementById('menuDrawer').scroll({top:0,behavior:'smooth'});
//     e.target.parentNode.parentNode.classList.add('active');
//     customHeaderMenu.querySelector('.main-header-wrapper').classList.add('show');
//     console.log(customHeaderMenu.querySelector('#menuDrawer'))
//     customHeaderMenu.querySelector('#menuDrawer').classList.add('show');
//     document.body.classList.add('custom-drawer-open');
//     setTimeout(()=>{
//       document.body.classList.add('custom-drawer-open-header-menu');
//     },500)
//     // console.log(e)
//   }
//   function onToggleSubmenu(e){
//     var target = e.target;
//     // console.log(target)
//     document.querySelectorAll('.grandchild-menu').forEach((ele)=> ele.classList.remove('show'));
//     var submenuHandle = target.getAttribute('data-submenu');
//       var grandSubMenuWrapper = document.querySelector('#submenuDrawer');
//       if(grandSubMenuWrapper){
//         var grandSubMenu = grandSubMenuWrapper.querySelector(`.grandchild-menu[id="submenu-${submenuHandle}"]`);
//         if(grandSubMenu){
//           grandSubMenu.classList.add('show');
//           document.body.classList.add('sbmenu-drawer-open');
//         }
//       }
//   }
//   // Close the drawers if the user clicks outside of them
//   window.onclick = function(event) {
//     if(window.innerWidth>768){
//     // console.log('event.target.id',event.target)
//     var drawer = document.getElementById("menuDrawer");
//     var submenuDrawer = document.getElementById("submenuDrawer");
    
//       if (!drawer.contains(event.target) && !submenuDrawer.contains(event.target) && event.target.id !== 'HeaderMenu-shop' && (event.target.parentNode.id !== 'mobile-menu-trigger')) {
//         customHeaderMenu.querySelector('.main-header-wrapper').classList.remove('show');
//         customHeaderMenu.querySelector('#menuDrawer').classList.remove('show');
//         document.querySelectorAll('.grandchild-menu').forEach((ele)=> ele.classList.remove('show'));
//         document.body.classList.remove('custom-drawer-open');
//         document.body.classList.remove('sbmenu-drawer-open');
//         document.body.classList.remove('custom-drawer-open-header-menu');
//         document.querySelectorAll('.list-menu li.active').forEach((ele)=> ele.classList.remove('active'));
        
//       }
//     }
//   };
// }


/*updted code*/

var customHeaderMenu = document.querySelector('header-drawer-custom');
if(customHeaderMenu){
  var hasMegamenu = document.querySelectorAll('.hasMegamenu');
  var MobileMenutrigger = document.querySelector('.mobile-menu-trigger svg#mobile-menu-trigger');
  var submenu = document.querySelectorAll('div.childmenu-item>a');
  var closeMenu = document.querySelector('.close-menu');
  var menuDrawer = document.getElementById('menuDrawer');
  var submenuDrawer = document.getElementById('submenuDrawer');
  var HasChild = document.querySelectorAll('.has-childmenu');

  // Track if mouse is inside the navigation (menuDrawer or submenuDrawer)
  let isHoveringNavigation = false;

  if(closeMenu){
    closeMenu.addEventListener('click', function(e){
      closeAllMenus();
    });
  }
  
  if(hasMegamenu){
    hasMegamenu.forEach((menu)=>{
     menu.addEventListener('click', onToggle.bind(this));      
    })
  }
  
  if(MobileMenutrigger) MobileMenutrigger.addEventListener('click', onMobileToggle.bind(this)); 

  function onMobileToggle(e){
    document.getElementById('menuDrawer').scroll({top:0, behavior:'smooth'});
    e.target.parentNode.parentNode.classList.add('active');
    customHeaderMenu.querySelector('.main-header-wrapper').classList.add('show');
    customHeaderMenu.querySelector('#menuDrawer').classList.add('show');
    document.body.classList.add('custom-drawer-open');
    document.querySelector('.main_link').classList.add('active')
  }
  
  if(submenu){
    submenu.forEach((menu) => {
      menu.addEventListener('mouseenter', onToggleSubmenu.bind(this));   
    });
  }

  if(HasChild){
    HasChild.forEach((child)=>{
      child.addEventListener('click', childMenu.bind(this));   
    })
  }
  
  // Add mouseenter and mouseleave events to track hover state for both menu and submenu
  if(menuDrawer){
    menuDrawer.addEventListener('mouseenter', function() {
      isHoveringNavigation = true;  // User is inside the navigation area
    });
    
    menuDrawer.addEventListener('mouseleave', function(e) {
      // Check if mouse is completely outside the navigation area (including submenu)
      if (!submenuDrawer.contains(e.relatedTarget)) {
        isHoveringNavigation = false;
        closeIfNotHovering();
      }
    });
  }

  if(submenuDrawer){
    submenuDrawer.addEventListener('mouseenter', function() {
      isHoveringNavigation = true; // User is inside the navigation area (submenu)
    });

    submenuDrawer.addEventListener('mouseleave', function(e) {
      // Check if mouse is completely outside the navigation area (including main menu)
       document.body.classList.remove('custom-drawer-open-header-menu');
      if (!menuDrawer.contains(e.relatedTarget)) {
        isHoveringNavigation = false;
        closeIfNotHovering();
      }
    });
  }
  function childMenu(e){
    e.preventDefault();
    document.querySelectorAll('.grandchild-menu').forEach((grandChild)=>{
      grandChild.classList.remove('show')
    })
    document.querySelectorAll('.main_link').forEach((mainMenu)=>{
      mainMenu.classList.remove('active')
    })
    e.target.parentNode.classList.add('active');
  }

  function onToggle(e){
    e.preventDefault();
    var target = e.target;
    document.getElementById('menuDrawer').scroll({top:0, behavior:'smooth'});
    e.target.parentNode.parentNode.classList.add('active');
    customHeaderMenu.querySelector('.main-header-wrapper').classList.add('show');
    customHeaderMenu.querySelector('#menuDrawer').classList.add('show');
    document.body.classList.add('custom-drawer-open');
    var submenuTarget = target.getAttribute('data-target');
    var SubMenu = document.querySelector(`.main_link[data-link="${submenuTarget}"]`);   
    document.querySelectorAll('.main_link').forEach((mainMenu)=>{
      mainMenu.classList.remove('active')
    })
    SubMenu.classList.add('active')
    setTimeout(() => {
      document.body.classList.add('custom-drawer-open-header-menu');
    }, 500);
  }

  function onToggleSubmenu(e){
    var target = e.target;
    document.querySelectorAll('.grandchild-menu').forEach((ele) => ele.classList.remove('show'));
     document.body.classList.remove('custom-drawer-open-header-menu');
    var submenuHandle = target.getAttribute('data-submenu');
    // console.log('submenuHandle',submenuHandle)
    var grandSubMenuWrapper = document.querySelector('#submenuDrawer');
    
    if(grandSubMenuWrapper){
      var grandSubMenu = grandSubMenuWrapper.querySelector(`.grandchild-menu[id="submenu-${submenuHandle}"]`);
      if(grandSubMenu){
        grandSubMenu.classList.add('show');
        document.body.classList.add('sbmenu-drawer-open');
      }
    }
  }

  // Close menus if the mouse is not hovering over the navigation area
  function closeIfNotHovering() {
    if (!isHoveringNavigation) {
      closeAllMenus();  // Close all menus when user leaves the entire navigation
    }
  }

  // Function to close all menus
  function closeAllMenus() {
    customHeaderMenu.querySelector('.main-header-wrapper').classList.remove('show');
    customHeaderMenu.querySelector('#menuDrawer').classList.remove('show');
     document.querySelectorAll('.main_link').forEach((ele) => ele.classList.remove('active'));
    document.querySelectorAll('.grandchild-menu').forEach((ele) => ele.classList.remove('show'));
    document.body.classList.remove('custom-drawer-open');
    document.body.classList.remove('custom-drawer-open-header-menu');
    document.body.classList.remove('sbmenu-drawer-open');
    document.querySelectorAll('.list-menu li.active').forEach((ele) => ele.classList.remove('active'));
  }
}


